import { gsap } from 'gsap';
import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} ListingFormProps
 */

/**
 * ListingForm ListingForm.
 * @augments {Base<ListingFormProps>}
 */
export default class Reset extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'Reset',
    refs: ['btn'],
    emits: ['click'],
    options: {
      visible: {
        default: 0,
        type: Number,
      },
    },
  };

  /**
   * Test if we are on the mobile version of the component or not.
   * @returns {boolean}
   */
  get isMobile() {
    return ['xxs', 'xs', 's'].includes(this.$services.get('resized').breakpoint);
  }

  /**
   *
   */
  mounted() {
    this.isVisible = this.$options.visible;

    this.tl = gsap.timeline();
    if (this.isVisible === 0) {
      this.tl.pause();
    }

    this.tl.fromTo(
      this.$el,
      {
        width: '0px',
        height: this.isMobile ? '0px' : '56px',
      },
      {
        width: '184px',
        height: 'auto',
        duration: 0.6,
        ease: 'back.out',
      },
    );
    this.tl.fromTo(
      this.$refs.btn,
      {
        y: 40,
      },
      {
        y: 0,
        duration: 0.8,
        ease: 'back.inOut',
      },
      '<=0.05',
    );
  }

  /**
   *
   */
  show() {
    this.isVisible = true;
    this.tl.play();
  }

  /**
   *
   */
  hide() {
    this.isVisible = false;
    this.tl.reverse();
  }

  /**
   *
   */
  onBtnClick() {
    this.hide();
    this.$emit('click');
  }
}
